// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"6f507a86","453":"e89051b5","866":"9501cd0c"}[chunkId] + ".chunk.js";
};